var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJapan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagJapan_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagJapan_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagJapan_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagJapan_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagJapan_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-12 44.114h70.482V3H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD0018",
    d: "M23.245 11.228c6.812 0 12.329 5.52 12.329 12.329 0 6.808-5.517 12.346-12.33 12.346-6.812 0-12.337-5.538-12.337-12.346s5.525-12.33 12.338-12.33"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0ib3BsN3YxOXc3YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJoMDVuMDByNjdiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI29wbDd2MTl3N2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNvcGw3djE5dzdhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjaDA1bjAwcjY3YikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTAgNDEuMTE0TDcwLjQ4MiA0MS4xMTQgNzAuNDgyIDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0FEMDAxOCIgZD0iTTM1LjI0NSA4LjIyOGM2LjgxMiAwIDEyLjMyOSA1LjUyIDEyLjMyOSAxMi4zMjkgMCA2LjgwOC01LjUxNyAxMi4zNDYtMTIuMzMgMTIuMzQ2LTYuODEyIDAtMTIuMzM3LTUuNTM4LTEyLjMzNy0xMi4zNDZzNS41MjUtMTIuMzMgMTIuMzM4LTEyLjMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIgMykiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlagJapan as ReactComponent };